import type {
  EnhancedCarouselLegacyApiProps,
  EnhancedCarouselProps,
} from '@backmarket/http-api/src/api-specs-content/models/enhanced-product-carousel'

const isContentServiceProps = (
  props: EnhancedCarouselLegacyApiProps | EnhancedCarouselProps,
): props is EnhancedCarouselProps => {
  return 'recommendation' in props.carousels[0]
}
export function mapLegacyEnhancedCarouselData(
  props: EnhancedCarouselLegacyApiProps | EnhancedCarouselProps,
): EnhancedCarouselProps {
  if (isContentServiceProps(props)) return props

  const { carousels, image, subtitle, title, ctaLink } = props

  const mappedCarousels = carousels.map<
    EnhancedCarouselProps['carousels'][number]
  >((carousel) => {
    return {
      id: carousel.id,
      thumbnail: carousel.image,
      thumbnailName: carousel.thumbnailName,
      recommendation: {
        hiddenDevices: [],
        id: `recco-${carousel.id}`,
        type: 'Recommendations',
        props: {
          widgetId: carousel.recommendations.widgetId,
        },
      },
    }
  })

  return {
    title,
    subtitle,
    image,
    cta: ctaLink,
    carousels: mappedCarousels,
  }
}
